import Cargos from '@/models/Cargos'

export default [
  {
    path: '/atendimento/servicos',
    name: 'rota-atendimento-servicos',
    autenticado: true,
    cargo: [Cargos.BARBEIRO, Cargos.LIDER, Cargos.BARBEIRO_CAIXA],
    titulo: 'Meus atendimentos',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Lançamentos',
      icon: 'cut',
    },
    component: () => import(/* webpackChunkName: "lancamento" */ '../views/lancamento/LancamentoServicos.vue'),
  },
  {
    path: '/atendimento/servicos/novo',
    name: 'rota-atendimento-servicos-novo',
    autenticado: true,
    cargo: [Cargos.BARBEIRO, Cargos.LIDER, Cargos.BARBEIRO_CAIXA],
    titulo: 'Novo atendimento',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "lancamento" */ '../views/lancamento/cadastro/LancamentoServicoCadastro.vue'),
  },
  {
    path: '/atendimento/servicos/:id',
    name: 'rota-atendimento-servicos-alteracao',
    autenticado: true,
    cargo: [Cargos.BARBEIRO, Cargos.LIDER, Cargos.BARBEIRO_CAIXA],
    titulo: 'Alteração atendimento',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "lancamento" */ '../views/lancamento/cadastro/LancamentoServicoCadastro.vue'),
  },
]
